import { render, staticRenderFns } from "./GuideGroupDetail.vue?vue&type=template&id=3939168e"
import script from "./GuideGroupDetail.vue?vue&type=script&lang=js"
export * from "./GuideGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./GuideGroupDetail.vue?vue&type=style&index=0&id=3939168e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports